import { create } from "zustand";
import { Socket } from "socket.io-client";
import { getUrlParams } from "./dataUtils";
import { appConfig } from "app/configs/appConfig";
import axios from "axios";
import { useDataStore } from "./dataStore";

type SocketStore = {
    //state..
    messageSocket: Socket | null
    isPolling: boolean;
    isConnected: boolean;
    pollingInterval: NodeJS.Timeout | null;

    //mutations..
    setIsConnected: (isConnecting: boolean) => void;
    setMessageSocket: (socket: Socket) => void,
    setIsPolling: (isPolling: boolean) => void;
    startPolling: () => any;
    stopPolling: () => void;
    pollForNewMessages: () => Promise<[]>
}

export const useSocketStore = create<SocketStore>((set, get) => ({
    messageSocket: null,
    isPolling: false,
    isConnected: false,
    pollingInterval: null,

    setMessageSocket: (socket: Socket) => set({ messageSocket: socket }),
    setIsPolling: (isPolling: boolean) => set({ isPolling }),
    setIsConnected: (isConnected: boolean) => set({ isConnected }),

    startPolling: async () => {
        const { isPolling, pollingInterval } = get();
        if (!isPolling && !pollingInterval) {
            const interval = setInterval(async () => {
                const newMessages = await get().pollForNewMessages();
                // Return newMessages to be used in the component
                return newMessages;
            }, 5000);
            set({ isPolling: true, pollingInterval: interval });
        }
    },
    stopPolling: () => {
        const { pollingInterval } = get();
        if (pollingInterval) {
          clearInterval(pollingInterval);
          set({ isPolling: false, pollingInterval: null });
        }
    },
    pollForNewMessages: async () => {
        const { chatId } = getUrlParams();
        const baseURL = process.env.NODE_ENV === 'development' ? appConfig.localChatServerURL : appConfig.serverChatBaseURL;
        try {
            const response = await axios.get(`${baseURL}/new-messages`, { params: { chat_id: chatId } });
            return response.data;
        } catch (error) {
            console.error("Error polling for new messages:", error);
            return [];
        }
    },
}));